import { render, staticRenderFns } from "./setting-header.vue?vue&type=template&id=18f68bd5&"
import script from "./setting-header.vue?vue&type=script&lang=js&"
export * from "./setting-header.vue?vue&type=script&lang=js&"
import style0 from "./setting-header.vue?vue&type=style&index=0&id=18f68bd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports